import React, { useState } from 'react';

import { NameChangeField, KeyField } from './TextField';
import { SaveChangesBtn, CloseBtn, GenKeyBtn } from './Button';

import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, List, ListItem, ListItemText, makeStyles, Checkbox, Switch } from '@material-ui/core';
import { CheckBox } from '@material-ui/icons';
import UserContext from '../context/userContext'

const useStyles = makeStyles((theme) => ({
    General : {
        backgroundColor: ' #1c1c1c',
        color: '#e5e7eb',
    },
    Title : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        marginTop : '1vh',
    },
    Content : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    color : {
        color : 'white',
    },
    label : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1rem !important',
        color : 'white',
    },
    dialog : {
        backgroundColor : 'black',
        color : 'white',
    },
    listItem : {
        marginBottom : '1vh',
        borderRadius : '5px',
        backgroundColor : 'black',
        color : 'white',
    },
    switchBase: {
        color: '#ff8141 !important',
        "&$checked": {
          color: '#fe752f !important',
        },
        "&$checked + $track": {
          backgroundColor: '#fe752f',
        }
      },
      checked: {
          color : '#fe752f'
      },
      track: {
        backgroundColor: '#ff8141 !important',
      },
      uncheckedProp : {
        color : '#fe752f !important',
          '& .MuiCheckbox-root' : {
              color : '#e5e7eb'
          },
          '& .MuiCheckbox-colorSecondary.Mui-checked ' : {
            color : '#fe752f',
            backgroundColor : '#e5e7eb',
        },
      },

}));

const CreateRoomDialog =  function CreateRoomDialog({ show, handleSavedChanges, closeDialogCallBack, handleKeyChange, privateRoom }){

    const classes = useStyles();
    const [ name, setName ] = useState(localStorage.getItem('UserName'));
    let configFile = localStorage.getItem('configFile');
    let visibility = localStorage.getItem('visibility');
    let configReceiver = localStorage.getItem('configReceiver');
    let autoClip = localStorage.getItem('autoClip');
    autoClip = (autoClip) ? (autoClip=='true') : false;

    if(privateRoom){
        visibility = false;
        configReceiver = true;
    } else {
        visibility = (visibility) ? (visibility=='true') : true;
        configReceiver = (configReceiver) ? (configReceiver=='true') : false;
    }
    configFile = (configFile) ? (configFile=='true') : true;
    const {teleport} = React.useContext(UserContext);
    const [ publicRoom , setPublic ] = useState(visibility);
    const [ filePrompt, setFilePrompt] = useState(configFile);
    const [ receiverPrompt, setReceiverPrompt] = useState(configReceiver);
    const [autoClipStatus, setAutoClipStatus] = useState(autoClip);
    var handleDialogClose = () => {
        if(!name){
            closeDialogCallBack(true);
        }else{
            closeDialogCallBack(false);
        }
    }


    var handleUserNameChange = (name) => {

        setName(name);
    }

    var handleSaveChangesBtn = () => {

        if(name === '' || !name){
            console.log("No user name detected");
        }else {
            handleSavedChanges({
                name, publicRoom
            })
        }

    }

    var handleAccessibilityChange = (event) => {
        localStorage.setItem("visibility",event.target.checked);
        setPublic(event.target.checked);
        teleport.setVisibility(event.target.checked);
    }

    //!Write code to take default values from localStorage. Else display default value in checkbox.
    var handleFilePromptValidation = () => {
        if(filePrompt) {
            setFilePrompt(false);
            localStorage.setItem("configFile",false);
        } else {
            setFilePrompt(true); 
            localStorage.setItem("configFile",true);
        }
    } 

    var handleReceiverPromptValidation = () => {
        if(receiverPrompt) {
            setReceiverPrompt(false);
            localStorage.setItem("configReceiver",false);
        } else {
            setReceiverPrompt(true); 
            localStorage.setItem("configReceiver",true);
        }
    } 

    var handleAutoClip = () => {
        if(autoClipStatus) {
            setAutoClipStatus(false);
            localStorage.setItem("autoClip",false);
        } else {
            setAutoClipStatus(true);
            localStorage.setItem("autoClip",true);
        }
    }
    

    return(
        <Dialog classes={{ paper : classes.dialog }} open={show || false} >
            <DialogTitle disableTypography={true} classes={{ root : classes.Title }} >
                Settings
                <CloseBtn view="desktop" handleClick={handleDialogClose} />
            </DialogTitle>
            <DialogContent classes={{ root : classes.Content }} >
                <Divider />
                <List>
                    <ListItem classes={{ root : classes.listItem }} >
                        <ListItemText classes={{ primary : classes.label }} primary="User name"  />
                    </ListItem>
                    <ListItem classes={{ root : classes.listItem }}>
                        <NameChangeField currname={name} handleChange={handleUserNameChange} />
                    </ListItem>
                    <Divider />
                    <ListItem classes={{ root : classes.listItem }}>
                        <ListItemText classes={{ primary : classes.label, secondary : classes.color }} primary="Make room public" secondary="This will make the rooms discoverable" />
                        <Switch
                            classes = {{ checked : classes.switchBase, track : classes.track, thumb : classes.thumb, primary : classes.primary }}
                            checked={publicRoom}
                            onChange={handleAccessibilityChange}
                            name="checkedB"
                        />
                    </ListItem>
                    <ListItem classes={{ root : classes.listItem }}>
                        <KeyField currname={localStorage.getItem('createRoom')} />
                        <GenKeyBtn  handleClick={handleKeyChange} />
                    </ListItem>
                    <ListItem classes={{ root : classes.listItem }}>
                        <ListItemText secondary="This will change the default room code." primary=""  classes={{ primary : classes.label, secondary : classes.color }} />
                    </ListItem>
                    <ListItem classes={{ root : classes.listItem }}>
                        <ListItemText classes={{ primary : classes.label, secondary : classes.color }} primary="Enable File prompt : " />
                        <Checkbox
                            size="medium"
                            onChange={handleFilePromptValidation}
                            checked={filePrompt}
                            classes={{ root : classes.uncheckedProp}}
                            style={{ color: '#fe752f !important' }}
                        />
                    </ListItem>
                    <ListItem classes={{ root : classes.listItem }}>
                        <ListItemText classes={{ primary : classes.label, secondary : classes.color }} primary="Enable Receiver prompt : " />
                        <Checkbox
                            size="medium"
                            onChange={handleReceiverPromptValidation}
                            checked={receiverPrompt}
                            classes={{ root : classes.uncheckedProp}}
                            style={{ color: '#fe752f !important' }}
                        />
                    </ListItem>
                    <ListItem classes={{ root : classes.listItem }}>
                        <ListItemText classes={{ primary : classes.label, secondary : classes.color }} primary="Auto clipboard copy : " />
                        <Checkbox
                            size="medium"
                            onChange={handleAutoClip}
                            checked={autoClipStatus}
                            classes={{ root : classes.uncheckedProp}}
                            style={{ color: '#fe752f !important' }}
                        />
                    </ListItem>
                </List>
                <Divider />
            </DialogContent>
            <DialogActions>
                <SaveChangesBtn handleClick={handleSaveChangesBtn} />
            </DialogActions>
        </Dialog>
    )

}

export default CreateRoomDialog;